import { render, staticRenderFns } from "./CentrumPage.vue?vue&type=template&id=38ecc140&scoped=true"
import script from "./CentrumPage.vue?vue&type=script&lang=js"
export * from "./CentrumPage.vue?vue&type=script&lang=js"
import style0 from "./CentrumPage.vue?vue&type=style&index=0&id=38ecc140&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ecc140",
  null
  
)

export default component.exports